// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

.deactivated-row {
  background-color: #f5f5f5;
  color: #a0a0a0;
}

.mat-column-select {
  overflow: initial;
  width: 50px;
}

th.mat-header-cell,
td.mat-cell {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBheW1lbnQtc3RhdHVzLXZlcmlmaWNhdGlvbi5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsV0FBVztBQUNiOztBQUVBO0VBQ0UseUJBQXlCO0VBQ3pCLGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxpQkFBaUI7RUFDakIsV0FBVztBQUNiOztBQUVBOztFQUVFLDZCQUE2QjtFQUM3Qiw4QkFBOEI7QUFDaEMiLCJmaWxlIjoicGF5bWVudC1zdGF0dXMtdmVyaWZpY2F0aW9uLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJ0YWJsZSB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uZGVhY3RpdmF0ZWQtcm93IHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2Y1ZjVmNTtcbiAgY29sb3I6ICNhMGEwYTA7XG59XG5cbi5tYXQtY29sdW1uLXNlbGVjdCB7XG4gIG92ZXJmbG93OiBpbml0aWFsO1xuICB3aWR0aDogNTBweDtcbn1cblxudGgubWF0LWhlYWRlci1jZWxsLFxudGQubWF0LWNlbGwge1xuICBwYWRkaW5nLWxlZnQ6IDEwcHggIWltcG9ydGFudDtcbiAgcGFkZGluZy1yaWdodDogMTBweCAhaW1wb3J0YW50O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/payment-status-verification/payment-status-verification.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,4yBAA4yB","sourcesContent":["table {\n  width: 100%;\n}\n\n.deactivated-row {\n  background-color: #f5f5f5;\n  color: #a0a0a0;\n}\n\n.mat-column-select {\n  overflow: initial;\n  width: 50px;\n}\n\nth.mat-header-cell,\ntd.mat-cell {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
